import './spinner.scss';
import classNames from 'classnames';

export const Spinner = ({ size = 2 }: { size?: number }) => {
  return (
    <div className={classNames('spinner', `text-[${size}em`)} data-cy="spinner">
      <i className="fa fa-spinner fa-spin"></i>
    </div>
  );
};
